import { useEffect, useState } from 'react';
import { formatInTimeZone } from 'date-fns-tz';
import type { EvidensiaClinic, EvidensiaTreatment } from './evidensia-clinics';
import { evidensiaClinicsCache } from './evidensia-clinics-cache.web';

export function useEvidensiaClinics(treatment: EvidensiaTreatment) {
  const [state, setState] = useState({
    treatment,
    clinics: [] as EvidensiaClinic[],
    loading: true,
    failed: false,
  });

  useEffect(() => {
    let mounted = true;
    const load = () => {
      const cached = evidensiaClinicsCache.get(treatment);
      setState({ treatment, clinics: cached ?? [], loading: cached === null, failed: false });
      void evidensiaClinicsCache.load(treatment).then((clinics) => {
        if (mounted)
          setState({
            treatment,
            clinics: clinics ?? [],
            loading: false,
            failed: clinics === null,
          });
      });
    };
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') load();
    };
    load();
    let day = formatInTimeZone(new Date(), 'Europe/Stockholm', 'yyyy-MM-dd');
    const timer = setInterval(() => {
      const currentDay = formatInTimeZone(new Date(), 'Europe/Stockholm', 'yyyy-MM-dd');
      if (currentDay !== day) {
        day = currentDay;
        load();
      }
    }, 60_000);
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      mounted = false;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      // Other widgets may still need the shared request.
    };
  }, [treatment]);

  return state.treatment === treatment
    ? state
    : { treatment, clinics: [], loading: true, failed: false };
}
